'use strict'

const SET_SHOW_USER_PREFERENCE_MODAL = "SET_SHOW_USER_PREFERENCE_MODAL";
const SET_USER_PREFERENCE_DATA = "SET_USER_PREFERENCE_DATA";
export {
    SET_SHOW_USER_PREFERENCE_MODAL,
    SET_USER_PREFERENCE_DATA,
}
